export default __webpack_public_path__ + "static/media/proces_logo.f2a6fa5b.png";